/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./detailsPage.vue?vue&type=template&id=11f95a1a"
import script from "./detailsPage.vue?vue&type=script&lang=js"
export * from "./detailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports